// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kp-0";
export var fileList = "_kp-2";
export var removeFileButton = "_kp-1";